module.exports = __webpack_public_path__ + "img/1F6A8.bc8c80df.svg";